import { DirectDebitValidationRequest } from '@dgx-pr-spa/shared/util';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { CompleteOrderBackendService } from '@complete-order/services/complete-order-backend.service';
import { BuildConfigService } from '@dgx-pr-spa/ui-components';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromDirectDebitValidation from '../actions/direct.debit.validation.action';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class DirectDebitEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly completeOrderBackendService: CompleteOrderBackendService,
    public readonly buildConfigService: BuildConfigService,
    private completeOrderService: CompleteOrderService
  ) {}

  loadDirectDebit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromDirectDebitValidation.loadDirectDebitValidation),
      switchMap(({ payload }: { payload: DirectDebitValidationRequest }) => {
        return this.completeOrderBackendService
          .postDirectDebit(
            /* eslint-disable no-irregular-whitespace */
            `${this.buildConfigService.config.common}​/v2/direct-debit/validate`,
            {
              branchCode: payload.branchCode,
              accountNumber: payload.accountNumber,
            }
          )
          .pipe(
            tap(({ isValid }) => {
              if (isValid) {
                this.completeOrderService.updateDirectDebitConfig({
                  reuse_dd_details: false,
                });
              }
            }),
            map((response) =>
              fromDirectDebitValidation.loadDirectDebitValidationSuccess({
                payload: response as { isValid: boolean },
              })
            ),
            catchError(() =>
              of(
                fromDirectDebitValidation.loadDirectDebitValidationFail({
                  payload: 'error',
                })
              )
            )
          );
      })
    )
  );
}
